import React from "react";
import { Typography, Box, Button, Paper, List, ListItem, ListItemText, Divider } from "@mui/material";
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import MyAccount from "../userMenu/MyAccount";
import MySubscription from "../userMenu/MySubscription";
import Notifications from "../userMenu/Notifications";
import { useTranslation } from 'react-i18next';

const UserMenu = ({ user, setUser, onItemSelected, onAccountLogout }) => {

    const { t } = useTranslation();

    const items = [
        {
          title: t('userMenu.account'),
          component: () => <MyAccount user={user} setUser={setUser} />,
          icon: <ManageAccountsIcon />
        },
        {
          title: t('userMenu.subscription'),
          component: () => <MySubscription user={user} />,
          icon: <CreditCardIcon />
        },
        {
          title: t('userMenu.notifications'),
          component: () => <Notifications user={user} setUser={setUser} />,
          icon: <NotificationsActiveIcon />
        }
    ];

    return (
        <Paper sx={{ padding: 2, width: 240}}>
        <Typography>{t('userMenu.greeting', { name: user.name })}</Typography>

        <Divider sx={{ marginTop: 1, marginBottom: 1 }}/>

        <List sx={{  }}>
            {items.map((item, index) => (
                <ListItem
                    button
                    key={index}
                    onClick={() => onItemSelected(item)}
                    sx={{ color: "#000" }}
                >
                    {item.icon}
                    <ListItemText sx={{ marginLeft: 1 }}
                        primary={item.title}
                    />
                </ListItem>
            ))}
        </List>
        <Divider/>
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
            <Button onClick={onAccountLogout} variant="outlined" sx={{ fontSize: 12 }} startIcon={<PowerSettingsNewIcon />}>
                {t('userMenu.logout')}
            </Button>
        </Box>
    </Paper>
    );
};

export default UserMenu;

